
import en from 'antd/locale/en_US';
import es from 'antd/locale/es_ES';
import pt from 'antd/locale/pt_PT';
import hi from 'antd/locale/hi_IN';
import ar from 'antd/locale/ar_EG';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/hi';
import 'dayjs/locale/ar';



import { decodeBase64URLToken } from "@utils/helper.js";
import { StorageKeys } from "@utils/LocalStorage";
import { getLocalStorageItem } from "@utils/storagelocal.js";
import { FEATURE_NAME } from '@common/redux/constants';
import { IProductTour, ProfileModel } from "@common/domain/models/Profile";
import { setFirstTimeUserAction } from "@common/redux/auth/actions";
import { IAttendee } from "@common/redux/meeting/interface";
import { showProfileModal, updateProfileDetails } from "@common/redux/profile/actions";

import { IUserModel } from '@models/Login';

import { AppLanguage } from "@translations/AppLanguage";
import { i18n } from '@translations/i18n';
import { i18n as interviewCoachI18n } from '@translations/placementPrepV2i18n';

import Navigator from '@navigator/index';
import { NavigationUrl, URLs } from '@navigator/NavigationUrl';

import {
    PORTUGUESE_MONTHS_ABBR, PORTUGUESE_MONTH_NAMES,
    SPANISH_MONTHS_ABBR, userRoles, platform, FEATURE_TOGGLE, DEFAULT_LANG_CODE,
    extractRouteFromFeatureKey, SPANISH_MONTH_NAMES,
    queryParamsTypes,
    SPANISH_WEEK_DAYS_ABBR,
    SPANISH_WEEK_DAYS_NAMES,
    PORTUGUESE_WEEK_DAYS_ABBR,
    PORTUGUESE_WEEK_DAYS_NAMES,
    HINDI_MONTHS_ABBR,
    HINDI_MONTH_NAMES,
    HINDI_WEEK_DAYS_ABBR,
    HINDI_WEEK_DAYS_NAMES,
    experienceLevelDetails
} from '@constants/config';
import { ModuleLevelActivityStatus } from '@constants/ReportConfig';

import { getRequiredIncompleteFields } from "@presentation/Profile/components/ProfileFields/utils";

import { WebStoreProviderService } from "@store/WebStoreProviderService";

import { getLanguage } from "./LanguageUtils";
import * as crypto from 'crypto';
import dayjs from 'dayjs';
import { resetCourseDetailFromCourseKey } from '@common/redux/course/actions';
import { customText } from '@presentation/Interview/config';
import moment, { Moment } from 'moment';
import { DATE_FORMAT_10, DATE_FORMAT_11, DATE_FORMAT_12, DATE_FORMAT_13, DATE_FORMAT_14 } from './DateHelper';


export const getLoggedInUserId = () => {
    const token = getLocalStorageItem(StorageKeys.ACCESS_TOKEN);
    let userId = undefined;
    if (!!token) {
        const userIdSub = decodeBase64URLToken(token);
        userId = userIdSub.sub;
    }
    return userId;
}

export const getUserUuid = () => {
    return getLocalStorageItem(StorageKeys.USER_UUID);
}

export const getUserRole = () => {
    const role = localStorage.getItem(StorageKeys.USER_ROLE);
    return (role === 'null') ? "" : role
}

export const getUserLang = () => {
    const language = localStorage.getItem(StorageKeys.PREFERRED_LANGUAGE);
    return (language === 'null') ? "" : language
}

export const setUserRole = (user) => {
    const role = user.profile && user.profile.role && user.profile.role[0];
    if (role) {
        localStorage.setItem(StorageKeys.USER_ROLE, role);
    }
};

export const storeUserData = (loginData: any, isSSO: boolean) => {
    const { preferences } = loginData;

    const accessToken = loginData?.accessToken;
    const userData = decodeBase64URLToken(accessToken);
    const emailId: string = userData?.email;
    localStorage.setItem(StorageKeys.ACCESS_TOKEN, accessToken);
    localStorage.setItem(StorageKeys.REFRESH_TOKEN, loginData?.refreshToken);
    localStorage.setItem(StorageKeys.IS_PROFILE_COMPLETED, preferences?.isProfileCompleted);
    localStorage.setItem(StorageKeys.IS_EMAIL_VERIFIED, preferences?.isEmailVerified);
    localStorage.setItem(StorageKeys.PREFERRED_LANGUAGE, preferences?.preferredLanguage);
    localStorage.setItem(StorageKeys.USER_ROLE, ((loginData.role && loginData.role[0]) || loginData?.role) as string);
    localStorage.setItem(StorageKeys.TEMP_PASS_GENERATED, preferences?.tempPasswordGenerated);
    localStorage.setItem(StorageKeys.EMAIL, emailId?.toLowerCase());
    localStorage.setItem(StorageKeys.USER, JSON.stringify(loginData));
    localStorage.setItem(StorageKeys.IS_TERMS_AND_CONDITIONS_ACCEPTED, preferences?.isTermsAndConditionsAccepted);
    if (!isSSO) {
        localStorage.setItem(StorageKeys.SHOW_APP_NUDGE, "true");
    } else {
        localStorage.setItem(StorageKeys.SHOW_APP_NUDGE, "false");
    }
};

export const authCheck = () => {
    const user: IUserModel = getUserModal();
    if (!user || !user.preferences) {
        // if no data
        return;
    }
    const { isProfileCompleted, tempPasswordGenerated } = user.preferences;
    setFirstTimeUserFlag(user);

    if (tempPasswordGenerated === 'true') {
        Navigator.replace(NavigationUrl.generate(URLs.changePassword));
    } else if ((isProfileCompleted === 'false' || !isProfileCompleted) && !getUserRole()) {
        Navigator.replace(NavigationUrl.generate(URLs.createProfile));
    };
};

const redirectToCourseDetailPage = (courseDetails) => {
    Navigator.replace(NavigationUrl.generate(URLs.courseDetails, { courseId: courseDetails?.id }));
    WebStoreProviderService.getStore().dispatch(resetCourseDetailFromCourseKey());
};

export const redirectToFeaturePage = (featureType) => {
    const url = extractRouteFromFeatureKey[featureType] || URLs.home;
    Navigator.replace(NavigationUrl.generate(url));
    if (localStorage.getItem(StorageKeys.FEATURE_KEY)) {
        localStorage.setItem(StorageKeys.FEATURE_KEY, '');
    }
};

export const handleAuthFlow = (currentPath?: string, profile?: ProfileModel) => {

    const user: IUserModel = getUserModal();
    if (!user || !user.preferences) {
        // if no data
        return;
    }

    const { isProfileCompleted, tempPasswordGenerated } = user.preferences;
    const isAuthenticated = WebStoreProviderService?.getStore()?.getState()?.auth?.isAuthenticated;
    const isCourseKeyDataExists = WebStoreProviderService?.getStore()?.getState()?.course?.courseDetailFromCourseKey || null;
    setFirstTimeUserFlag(user);
    const courseKey = getQueryParams(queryParamsTypes.courseKey) || localStorage.getItem(StorageKeys.COURSE_KEY);
    const featureKey = getQueryParams(queryParamsTypes.featureKey) || localStorage.getItem(StorageKeys.FEATURE_KEY);
    //@ts-ignore
    if (platform.WITP) {
        if (tempPasswordGenerated === 'true') {
            Navigator.replace(NavigationUrl.generate(URLs.changePassword, { courseKey }));
        }
        else if (isProfileCompleted === 'false' && getUserRole() !== userRoles.faculty) {
            Navigator.replace(NavigationUrl.generate(URLs.createProfile, { courseKey }));
        }
        else if (isAuthenticated) {
            Navigator.replace(NavigationUrl.generate(URLs.home));
        }
    } else if (platform.WO) {
        if (tempPasswordGenerated === 'true') {
            const changePasswordOnboardingStepRoute = NavigationUrl.generate(URLs.changePassword, { courseKey, featureKey });
            (!currentPath || (currentPath && !currentPath.includes(changePasswordOnboardingStepRoute))) && Navigator.replace(changePasswordOnboardingStepRoute);
        }

        else if ((!isProfileCompleted || isProfileCompleted === 'false') && !getUserRole()) {
            const createProfileOnbaordingStepRoute = NavigationUrl.generate(URLs.createProfile, { courseKey, featureKey });
            (!currentPath || (currentPath && !currentPath.includes(createProfileOnbaordingStepRoute))) && Navigator.replace(createProfileOnbaordingStepRoute);
        }
        else if ((isProfileCompleted || isProfileCompleted === 'true' || !getUserRole()) && profile) {
            checkAndHandleIncompleteStudentProfile(profile);
            if (isCourseKeyDataExists) {
                redirectToCourseDetailPage(isCourseKeyDataExists);
            } else if (featureKey) {
                redirectToFeaturePage(featureKey);
            }
        }
        else if (!currentPath && !profile && isAuthenticated) {
            if (isCourseKeyDataExists) {
                redirectToCourseDetailPage(isCourseKeyDataExists);
            } else if (featureKey) {
                redirectToFeaturePage(featureKey);
            } else {
                const homeRoute = NavigationUrl.generate(URLs.home);
                (!currentPath || (currentPath && !currentPath.includes(homeRoute))) && Navigator.replace(homeRoute);
            }
        }
    }

}


export const setFirstTimeUserFlag = (user: IUserModel) => {

    const { isProfileCompleted, tempPasswordGenerated } = user.preferences;

    if (
        tempPasswordGenerated === 'true' ||
        ((!isProfileCompleted || isProfileCompleted === 'false') && !getUserRole())
    ) {
        WebStoreProviderService.getStore().dispatch(setFirstTimeUserAction(true));
    }
}


export const checkAndHandleIncompleteStudentProfile = (profile: ProfileModel) => {

    const { incompleteFields } = getRequiredIncompleteFields(profile);
    if (incompleteFields.length > 0)
        WebStoreProviderService.getStore().dispatch(showProfileModal(true));

}

export const updateTempPasswordFlag = (value: string) => {
    localStorage.setItem(StorageKeys.TEMP_PASS_GENERATED, value);
    localStorage.setItem(StorageKeys.IS_TERMS_AND_CONDITIONS_ACCEPTED, "true");
    const user = getUserModal();
    if (user) {
        user.preferences.tempPasswordGenerated = value;
        user.isTermsAndConditionsAccepted = "true";
        updateUserModal(user);
    }
};

export const getUserModal = () => {
    const user = localStorage.getItem(StorageKeys.USER);
    if (user) {
        return JSON.parse(user);
    }
    return null;
}

export const updateUserModal = (user: IUserModel) => {
    localStorage.setItem(StorageKeys.USER, JSON.stringify(user));
}

export const getUserEmail = () => {
    return localStorage.getItem(StorageKeys.EMAIL);
};

export const getUserName = () => {
    return localStorage.getItem(StorageKeys.USER_NAME)
}

export const updateProfileCompletedFlag = (value: string) => {
    localStorage.setItem(StorageKeys.IS_PROFILE_COMPLETED, value);
    // update role to student
    localStorage.setItem(StorageKeys.USER_ROLE, userRoles.student);

    const user = getUserModal();
    if (user) {
        user.preferences.isProfileCompleted = value;
        updateUserModal(user);
    }
}

export const getTermsAndConditions = () => {
    return localStorage.getItem(StorageKeys.IS_TERMS_AND_CONDITIONS_ACCEPTED);
};

export const getAttendeesList = (attendees: ProfileModel[]): IAttendee[] => {
    return (
        attendees.map((student: ProfileModel) => {
            return {
                userId: student.getUserId(),
                organizer: student.getUserId() === getLoggedInUserId(),
                email: student.getEmail(),
            }
        })
    )
};

export const getCalendarLanguage = () => {
    switch (getLanguage()) {
        case AppLanguage.Spanish: {
            moment.locale(AppLanguage.Spanish, {
                monthsShort: SPANISH_MONTHS_ABBR,
                months: SPANISH_MONTH_NAMES,
                weekdaysShort: SPANISH_WEEK_DAYS_ABBR,
                weekdays: SPANISH_WEEK_DAYS_NAMES,
            });
            return es;
        }
        case AppLanguage.Portuguese: {
            moment.locale(AppLanguage.Portuguese, {
                monthsShort: PORTUGUESE_MONTHS_ABBR,
                months: PORTUGUESE_MONTH_NAMES,
                weekdaysShort: PORTUGUESE_WEEK_DAYS_ABBR,
                weekdays: PORTUGUESE_WEEK_DAYS_NAMES,
            });
            return pt;
        }
        case AppLanguage.English: {
            return en;
        }
        case AppLanguage.Hindi: {
            moment.locale(AppLanguage.Hindi, {
                monthsShort: HINDI_MONTHS_ABBR,
                months: HINDI_MONTH_NAMES,
                weekdaysShort: HINDI_WEEK_DAYS_ABBR,
                weekdays: HINDI_WEEK_DAYS_NAMES,
            });
            return hi;
        }
        case AppLanguage.Arabic: {
            return ar;
        }
        default:
            return en;
    }
}

export const sortMembersByRole = (members) => {
    return members.sort((a, b) => {
        let first = a.getRole().toLowerCase();
        let second = b.getRole().toLowerCase();

        if (first < second)
            return -1;
        if (first > second)
            return 1;
        return 0;
    });
}

export const getModuleLevelActivityStatusForView = (status: ModuleLevelActivityStatus) => {
    switch (status) {
        case `${ModuleLevelActivityStatus.NotAttemptedLessons}`:
            return i18n.t(`report.labelsAndTitles.NOT_ATTEMPTED_LESSONS`);
        case ModuleLevelActivityStatus.AttemptedLessons:
            return i18n.t(`report.labelsAndTitles.ATTEMPTED_LESSONS`);
        case ModuleLevelActivityStatus.CompletedLessons:
            return i18n.t(`report.labelsAndTitles.COMPLETED_LESSONS`);
        default:
            return "";
    }
}

export const getEducationQualification = (education) => {
    switch (education) {
        case 'Below 10th':
            return i18n.t(`auth.labelsAndTitles.BELOW_TENTH`);
        case 'Below 12th':
            return i18n.t(`auth.labelsAndTitles.BELOW_TWELFTH`);
        case 'ITI/Polytechnic':
            return i18n.t(`auth.labelsAndTitles.POLYTECHNIC`);
        case 'College Dropout':
            return i18n.t(`auth.labelsAndTitles.COLLEGE_DROPOUT`);
        case 'Graduate':
            return i18n.t(`auth.labelsAndTitles.GRADUATE`);
        default:
            return "";
    }
}

export const getLanguagesForView = (language, providedI18n = null) => {
    const defaultI18n = providedI18n ?? i18n;
    switch (language) {
        case 'English':
        case 'en':
            return defaultI18n.t(`global.labelsAndTitles.ENGLISH`);
        case 'English-US':
        case 'en-Us':
            return defaultI18n.t(`global.labelsAndTitles.ENGLISH_US`);
        case 'Spanish':
        case 'es':
            return defaultI18n.t(`global.labelsAndTitles.SPANISH`);
        case 'Portuguese':
        case 'pt':
            return defaultI18n.t(`global.labelsAndTitles.PORTUGUESE`);
        case 'Hindi':
        case 'hi':
            return defaultI18n.t(`global.labelsAndTitles.HINDI`);
        case 'Arabic':
        case 'ar':
            return defaultI18n.t(`global.labelsAndTitles.ARABIC`);
        case 'Bahasa':
        case 'id':
            return defaultI18n.t(`global.labelsAndTitles.BAHASA`);
        case 'Filipino':
        case 'fil':
            return defaultI18n.t(`global.labelsAndTitles.FILLIPINO`);
        default:
            return "";
    }
}

export const getLanguageFromCode = (languageCode) => {
    switch (languageCode) {
        case AppLanguage.English:
            return i18n.t(`global.labelsAndTitles.ENGLISH`);
        case AppLanguage.Portuguese:
            return i18n.t(`global.labelsAndTitles.PORTUGUESE`);
        case AppLanguage.Spanish:
            return i18n.t(`global.labelsAndTitles.SPANISH`);
        case AppLanguage.Hindi:
            return i18n.t(`global.labelsAndTitles.HINDI`);
        case AppLanguage.Arabic:
            return i18n.t(`global.labelsAndTitles.ARABIC`);
        case AppLanguage.Bahasa:
            return i18n.t(`global.labelsAndTitles.BAHASA`);
        case AppLanguage.Filipino:
            return i18n.t(`global.labelsAndTitles.FILLIPINO`);
        case AppLanguage.EnglishUS:
            return i18n.t(`global.labelsAndTitles.ENGLISH_US`);
        default:
            return i18n.t(`global.labelsAndTitles.ENGLISH`);
    }
}

export const getUserLanguages = (language) => {
    switch (language) {
        case 'Inglês':
            return 'English';
        case 'Inglês-EUA':
            return 'English-US';
        case 'Espanhola':
            return 'Spanish';
        case 'Português':
            return 'Portuguese';
        case 'Hindi':
            return 'Hindi';
        case 'Arabic':
            return 'Arabic';
        default:
            return "";
    }
}

export const storeSocialMediaUserInfo = (userInfo) => {
    localStorage.setItem(StorageKeys.SOCIAL_MEDIA_USER_INFO, JSON.stringify(userInfo));
}




export const getHmacKey = (clientKey: string, msg: string) => {
    return crypto.createHmac('sha256', clientKey).update(msg).digest('hex');
}

export const getZoomIDFromZoomMeetingURL = (url: string) => {
    const regex = /\/j\/(\d+)/;
    const match = url.match(regex);

    if (match) {
        const id = match[1];
        return id
    }
}

export const formStringWithAllDependenciesAppended = (str: string, dependencies: any) => {
    for (const key in dependencies) {
        if (dependencies.hasOwnProperty(key)) {
            const placeholder = new RegExp(`\\{${key}\\}`, 'g');
            const value = dependencies[key];
            str = str.replace(placeholder, value);
        }
    }
    return str;
}

export const makeUpdateProfileApiCall = (userProfile: ProfileModel, productTours: IProductTour[]) => {
    const currentTours = userProfile?.getProductTours() || [];

    const updatedTours = [...currentTours];

    productTours.forEach(({ name, status }) => {
        const updatedTour = {
            name,
            acknowledgedAt: new Date().toISOString(),
            status
        };

        const existingTourIndex = updatedTours.findIndex(tour => tour.name === name);

        if (existingTourIndex === -1) {
            updatedTours.push(updatedTour);
        } else {
            updatedTours[existingTourIndex] = updatedTour;
        }
    });

    const apiParams = {
        firstName: userProfile?.getFirstName(),
        lastName: userProfile?.getLastname(),
        ...(userProfile?.getEmail()?.length > 0 && { email: userProfile?.getEmail() }),
        productTours: updatedTours
    };

    WebStoreProviderService.getStore().dispatch(updateProfileDetails(apiParams, getLoggedInUserId()));
};


export const isFeatureEnabled = (featureName: string, profileInfo: ProfileModel) => {
    /* For language specific changes*/
    // const lang = profileInfo?.getPreferredLanguage();
    const betaFeatures: string[] = profileInfo?.getBetaFeatures() || [];
    let returnVal = false;
    switch (featureName) {

        case FEATURE_NAME.AICOACH:
            returnVal = (FEATURE_TOGGLE.aiCoach || betaFeatures.includes(featureName));
            break;

        case FEATURE_NAME.INTERVIEW_PREP:
            returnVal = (FEATURE_TOGGLE.interviewPrep || betaFeatures.includes(featureName));
            break;

        case FEATURE_NAME.PITCH_TRAINER:
            returnVal = (FEATURE_TOGGLE.pitchTariner || betaFeatures.includes(featureName));
            break;

        case FEATURE_NAME.FORUM:
            returnVal = FEATURE_TOGGLE.forums;
            break;

        case FEATURE_NAME.NEWUITOUR:
            returnVal = FEATURE_TOGGLE.newUiTour;
            break;

        case FEATURE_NAME.CAREERS:
            returnVal = FEATURE_TOGGLE.careers;
            break;

        case FEATURE_NAME.LIBRARY:
            returnVal = FEATURE_TOGGLE.library;
            break;

        case FEATURE_NAME.FRESHDESK:
            returnVal = (FEATURE_TOGGLE.freshdesk || betaFeatures.includes(featureName));
            break

        case FEATURE_NAME.MENTORS:
            returnVal = betaFeatures.includes(featureName);
            break;

        default:
            returnVal = false;
            break;
    }
    return returnVal;

}


export const adjustLanguage = (language: string): string => {
    let returnVal = DEFAULT_LANG_CODE;
    switch (language) {
        case 'pt':
            returnVal = 'pt-BR';
        case 'hi':
            returnVal = 'en';
        default:
            returnVal = DEFAULT_LANG_CODE;
    }
    return returnVal;
}

export const getQueryParams = (key) => {
    const searchElement = new URLSearchParams(location.search);
    return searchElement.get(key);
};

export const getCourseKeyUrl = (url, params) => {
    let defaultUrl = url;
    if (params?.courseKey) {
        defaultUrl = `${defaultUrl}${params?.courseKey && `?courseKey=${params.courseKey}`}`;
    } else if (params?.featureKey) {
        defaultUrl = `${defaultUrl}${params?.featureKey && `?featureKey=${params.featureKey}`}`;
    };
    return defaultUrl;
};


export const deepClone = (obj) => {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    // Handle Date
    if (obj instanceof Date) {
        return new Date(obj);
    }

    // Handle Array
    if (Array.isArray(obj)) {
        return obj.map(deepClone);
    }

    // Handle Object
    const cloned = Object.create(Object.getPrototypeOf(obj));
    for (let key of Reflect.ownKeys(obj)) {
        cloned[key] = deepClone(obj[key]);
    }
    return cloned;
}

export const isIOS = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isAndriod = () => {
    return /Android/i.test(navigator.userAgent);
};

export const getExperienceInformation = (country, language) => {
    return experienceLevelDetails[country] ? (experienceLevelDetails[country][language] || experienceLevelDetails[country][AppLanguage.English]) : (experienceLevelDetails[customText.india][language] || experienceLevelDetails[customText.india][AppLanguage.English]);
};
export const PREFIX_NOTIFICATION = "WEEKLY_SLOT_BOOKING_ALERT";
export const checkIfNotificationAlreadyShown = () => {
    for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).substring(0, 25) === PREFIX_NOTIFICATION) {
            const key = localStorage.key(i);
            const date = key.replace(PREFIX_NOTIFICATION, '');
            if (date === moment().format('YYYY-MM-DD')) {
                return true;
            }
        }
    }
    return false;
}

export const deleteOldKey = () => {
    for (let i = 0; i < localStorage.length; i++) {
        if (localStorage.key(i).substring(0, 25) === PREFIX_NOTIFICATION) {
            const key = localStorage.key(i);
            const date = key.replace(PREFIX_NOTIFICATION, '');
            if (date !== moment().format('YYYY-MM-DD')) {
                localStorage.removeItem(key);
            }
        }
    }
}

export const groupByDates = (dateOverridesClone: { date: string }[]) => {
    const dates = dateOverridesClone?.map((date) => moment(date.date)) ?? [];
    const sortedDates = dates.sort((a, b) => a.diff(b, 'days'));
    let count = 0;
    if (!sortedDates.length) {
        return {}
    }
    const group = { 0: [sortedDates[0]] };
    sortedDates.forEach((date, index) => {
        if (index + 1 <= sortedDates.length - 1) {
            const nextDate = sortedDates[index + 1];
            const isSameMonth = date.month() === nextDate?.month();
            if (nextDate && date.diff(nextDate, "days") === -1 && isSameMonth) {
                group[count].push(nextDate);
            } else {
                count += 1;
                group[count] = [nextDate];
            }
        }
    });
    return group;
}

export const formatOverrideDates = (groupByContinousDates: { [key: string]: Moment[] }) => {
    const final = Object.values(groupByContinousDates).reduce((acc, dates: Moment[]) => {
        const startDate = dates[0];
        const endDate = dates[dates.length - 1];
        const month = startDate.format(DATE_FORMAT_13);
        if (!acc[month]) {
            acc[month] = [];
        }
        if (dates.length === 1) {
            acc[month].push({
                startDate,
                endDate,
                text: moment(startDate).format(DATE_FORMAT_10),
            });
        } else {
            acc[month].push({
                startDate,
                endDate,
                text: `${startDate.format(DATE_FORMAT_12)} - ${endDate.format(DATE_FORMAT_12)}, ${startDate.format(DATE_FORMAT_14)} - ${endDate.format(DATE_FORMAT_11)}`,
            })
        }
        return acc;
    }, {});
    return final;
}

export function generateTimeSlots(interval = 15) {
    const slots = [];
    for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += interval) {
            const value = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
            const period = hour < 12 ? 'AM' : 'PM';
            const displayHour = hour % 12 === 0 ? 12 : hour % 12;
            const label = `${String(displayHour).padStart(2, '0')}:${String(minute).padStart(2, '0')} ${period}`;
            slots.push({ value, label });
        }
    }
    return slots;
}

const minTranslate = i18n.t("events.labelsAndTitles.MIN")
export const defaultDurationList = [
    {
        "label": `15 ${minTranslate}`,
        "value": 15
    },
    {
        "label": `30 ${minTranslate}`,
        "value": 30
    },
    {
        "label": `40 ${minTranslate}`,
        "value": 40
    },
    {
        "label": `60 ${minTranslate}`,
        "value": 60
    }
]

export const defaultWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export const convertToMinutes = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
}
